import { IonSpinner } from "@ionic/react";
import styled, { css } from "styled-components";

interface CTAProps {
	children?: React.ReactNode;
	onClick?: () => void;
	disabled?: boolean;
	loading?: boolean;
	customCTAstyles?: any;
	hide?: boolean;
	animated?: boolean
}

const CTA = styled.button<any>`
	outline: none;
	border: none;
	position: absolute;
	bottom: 0;
	height: 62px;
	padding: 0 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #ffcc00;
	color: #000;
	width: 100%;
	z-index: 101;
	text-transform: uppercase;
	font-weight: 600;
	font-size: 20px;
	${(props) =>
		props.disabled &&
		css`
			pointer-events: none;
			&:before {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.5); 
			}
		`}
	${(props) =>
		props.hide &&
		css`
			display: none;
			pointer-events: none;
		`};
	${(props) =>
		props.customStyles &&
		css`
			${props.customStyles}
		`}
`;

const Center = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

const BottomCTA = (props: CTAProps) => {
	const { children, onClick, disabled, customCTAstyles = {}, hide, loading, animated } = props;
	const buttonDisabled = disabled || loading;
	return (
		<CTA style={customCTAstyles} hide={hide} onClick={onClick} disabled={buttonDisabled} className={!buttonDisabled && animated ? "shine" : ""}>
			{loading ? <Center><IonSpinner name='dots' color={"#000"} /></Center> : children}
		</CTA> 
	);
};

export default BottomCTA;
